import React from 'react'
import { FormNewText } from '../../../../../../shared/form-new/form-text'
import { FormNewTextArea } from './fields'

// Contacts (who we warn about expiring credentials) and what people see when
// they aren't set up yet. Same fields and components as the old form (the
// icon lives in the identity section, spec section 1).
export const SectionHelp = () =>
  <div className="row g-3">
    <div className="col-md-6"><FormNewText name="contactName" label="Contact name" placeholder="Name of the person to contact" /></div>
    <div className="col-md-6"><FormNewText name="contactEmail" label="Contact email" placeholder="it-support@example.org" /></div>
    <div className="col-12">
      <FormNewText name="helpUrl" label="Access-request link" placeholder="https://example.org/request-access"
        subtext="Shown to people who sign in but aren't enrolled yet." />
    </div>
    <div className="col-12"><FormNewTextArea name="helpText" label="Help text" placeholder="What people should do to get access." /></div>
  </div>
